import { render, staticRenderFns } from "./GoodsFormDialog.vue?vue&type=template&id=1063905a&scoped=true"
import script from "./GoodsFormDialog.vue?vue&type=script&lang=js"
export * from "./GoodsFormDialog.vue?vue&type=script&lang=js"
import style0 from "./GoodsFormDialog.vue?vue&type=style&index=0&id=1063905a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1063905a",
  null
  
)

export default component.exports